import { z } from 'zod';

const ProdutoVariacaoValorSchema = z.object({
    vrr_em_uso: z.enum(['S', 'N']),
    vrr_empresa_idpk: z.number(),
    vrr_idpk: z.number(),
    vrr_valor: z.string(),
    vrr_variacao_idpk: z.number(),
});

export type ProdutoVariacaoValor = z.infer<typeof ProdutoVariacaoValorSchema>;

export const ProdutoVariacaoSchema = z.object({
    total_registros: z.number().optional(),
    valor: ProdutoVariacaoValorSchema.array().nullable(),
    var_cor: z.string().nullable(),
    var_descricao: z.string(),
    var_empresa_idpk: z.number(),
    var_idpk: z.number(),
    var_nome: z.string(),
    var_ultima_alteracao: z.string(),
});

export type ProdutoVariacao = z.infer<typeof ProdutoVariacaoSchema>;
